import React from 'react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Cell, ResponsiveContainer
} from 'recharts';

const OfferRateByClientChart = ({ data }) => {
  const clientMap = {};
  (data || []).forEach(r => {
    const c = r.client || 'Unknown';
    if (!clientMap[c]) clientMap[c] = { client: c, accepted: 0, rejected: 0 };
    clientMap[c].accepted += r.offersAccepted || 0;
    clientMap[c].rejected += r.offersRejected || 0;
  });

  const chartData = Object.values(clientMap)
    .filter(d => d.accepted + d.rejected > 0)
    .map(d => ({
      ...d,
      rate: Math.round((d.accepted / (d.accepted + d.rejected)) * 100),
    }))
    .sort((a, b) => b.rate - a.rate);

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const item = payload[0].payload;
      return (
        <div style={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06)', fontSize: '12px', padding: '8px 12px', background: '#fff' }}>
          <p className="font-semibold text-gray-800">{item.client}</p>
          <p className="text-green-600">{item.accepted} accepted</p>
          <p className="text-red-500">{item.rejected} rejected</p>
          <p className="text-gray-500 text-xs">{item.rate}% acceptance rate</p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="dashboard-card p-6 slide-in-up">
      <div className="flex justify-between items-center mb-3">
        <h3 className="text-lg font-semibold text-gray-800">Offer Acceptance Rate by Client</h3>
        <div className="bg-green-100 text-green-800 text-xs font-medium px-2.5 py-1 rounded-full">
          Filtered Data
        </div>
      </div>
      <p className="text-sm text-gray-600 mb-4">Percentage of offers accepted per client for selected filters</p>
      {chartData.length === 0 ? (
        <div className="flex items-center justify-center h-48 text-gray-400 text-sm">No offer data available</div>
      ) : (
        <ResponsiveContainer width="100%" height={250}>
          <BarChart data={chartData} margin={{ top: 4, right: 16, left: 0, bottom: 60 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" vertical={false} />
            <XAxis dataKey="client" tickLine={false} axisLine={false} style={{ fontSize: '12px' }} angle={-30} textAnchor="end" interval={0} />
            <YAxis tickLine={false} axisLine={false} style={{ fontSize: '12px' }} domain={[0, 100]} unit="%" />
            <Tooltip content={<CustomTooltip />} />
            <Bar dataKey="rate" name="Acceptance Rate %" radius={[4, 4, 0, 0]}>
              {chartData.map((entry, index) => (
                <Cell
                  key={index}
                  fill={entry.rate >= 75 ? '#10b981' : entry.rate >= 50 ? '#f59e0b' : '#ef4444'}
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default OfferRateByClientChart;
